import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import {
  FcMapNetworkResponse,
} from 'webcommon/shared';
import { PrmHttpClientService } from '../PrmHttpClientService';

@Injectable({
  providedIn: 'root',
})
export class NetworkRepository {
  constructor(private httpClientService: PrmHttpClientService) {}

  private readonly networksRoutePrefix = 'networks/id';

  public getNetworksItems(id: string, uId: string): Observable<string[]> {
    const endpointUrl = `${this.networksRoutePrefix}/${id}/item/${uId}`;
    return this.httpClientService.sendGetRequest(endpointUrl);
  }

  public updateNetworksItems(id: string, uId: string, guids: string[]): Observable<FcMapNetworkResponse> {
    const endpointUrl = `${this.networksRoutePrefix}/${id}/update/${uId}`;
    return this.httpClientService.sendPutRequest(endpointUrl, guids);
  }

  public deleteNetworksItem(id: string): Observable<FcMapNetworkResponse> {
    const endpointUrl = `${this.networksRoutePrefix}/${id}/delete`;
    return this.httpClientService.sendDeleteRequest(endpointUrl);
  }
}
